export default "__VITE_ASSET__b31cfaf1__"